import { useState } from 'react';
import ImageLoader from '../components/ImageLoader'
import Lightbox from '../components/Lightbox';
import ThumbnailPicker from '../components/ThumbnailPicker'


const items = [
    { src:require("../images/design/img--design-1.jpg").default, caption:"Exterior from Strangers Creek", x:710, y:204, width:265, height:245 },
    { src:require("../images/design/img--design-2.jpg").default, caption:"Exterior from Spurway Drive", x:990, y:204, width:265, height:245},
    { src:require("../images/design/img--design-3.jpg").default, caption:"Exterior from Fairway Drive", x:1275, y:204, width:265, height:245 },
    { src:require("../images/design/img--design-4.jpg").default, caption:"Exterior from Corner", x:1555, y:204, width:265, height:245 },
    { src:require("../images/design/img--design-5.jpg").default, caption:"Pool", x:710, y:468, width:265, height:245 },
    { src:require("../images/design/img--design-6.jpg").default, caption:"Pool", x:990, y:468, width:265, height:245 },
    { src:require("../images/design/img--design-7.jpg").default, caption:"Communal Walkway", x:1275, y:468, width:265, height:245 },
    { src:require("../images/design/img--design-8.jpg").default, caption:"Communal Water Feature", x:1555, y:468, width:265, height:245 },
    { src:require("../images/design/img--design-9.jpg").default, caption:"Communal Space Exterior", x:710, y:732, width:265, height:245 },
    { src:require("../images/design/img--design-10.jpg").default, caption:"Communal Space Interior", x:990, y:732, width:265, height:245 },
    { src:require("../images/design/img--design-11.jpg").default, caption:"Entry Gate", x:1275, y:732, width:265, height:245 },
    { src:require("../images/design/img--design-12.jpg").default, caption:"Breezeway", x:1555, y:732, width:265, height:245 },
]


export default function(){
    const [selection, setSelection] = useState<string|null>(null);

    return (
        <div>
            <ThumbnailPicker onSelected={setSelection} items={items}/>
            <Lightbox items={items} selection={selection} onSelected={setSelection} carousel={true}/>
            <ImageLoader src={require("../images/design/bkg--design-1.jpg").default} />
        </div>
    )
}